import { useQuery } from '@tanstack/react-query';
import { getChangesQueryOptions } from '@/features/dashboard/bookingChanges/hooks/useGetChanges.ts';
import { BookingChangeListDto } from '@/features/dashboard/bookingChanges/types/dto/BookingChangeListDto.ts';
import { bookingChangeHistoryMapper } from '@/features/dashboard/bookingChanges/types/BookingChangeHistoryDto.mapper.ts';

/** Historia paczek — karta „Ostatnie zmiany” i pełna tabela historii. */
const useGetChangeHistory = (bookingId: string | undefined) =>
  useQuery({
    ...getChangesQueryOptions(bookingId),
    select: (changes: BookingChangeListDto[]) =>
      bookingChangeHistoryMapper.toHistoryList(changes),
  });

export default useGetChangeHistory;
